export class SelectedTableElement {
  private _selectedElementId?: string;
  private _currentPage?: number;

  public setSelectedElementId(id: string, currentPage: number): void {
    this._selectedElementId = id;
    this._currentPage = currentPage;
  }

  public get selectedElementId(): string | undefined {
    return this._selectedElementId;
  }

  public get currentPage(): number | undefined {
    return this._currentPage;
  }

  public get isElementSelected(): boolean {
    return !!this._selectedElementId;
  }

  public clearSelection(): void {
    this._selectedElementId = undefined;
    this._currentPage = undefined;
  }
}
